'use es6';
/**
 * @typedef {Object} AnnotationType
 * @property {UInt} ERROR
 * @property {UInt} INFO
 * @property {UInt} WARNING
 */

/**
 * Flag enum of valid types for an `Annotation` model's `type` field.
 *
 * @enum {UInt}
 * @readonly
 */

export default Object.freeze({
  ERROR: 1,
  INFO: 2,
  WARNING: 4
});